
// Vue reactivity
import { computed, ref, watch } from 'vue';

// icons
import { arrowBack, } from 'ionicons/icons';

// components
import { IonPage, IonGrid, IonHeader, IonFooter, IonToolbar, IonTitle, IonContent, IonSpinner,
        IonButtons, IonButton, IonIcon, IonLabel, IonBackButton, IonCard, IonItem, IonSelect, IonSelectOption,
        onIonViewDidEnter, onIonViewWillLeave, } from '@ionic/vue';
import ABEventsDetails from "@/components/secondary/events/ABEventsDetails.vue";

// API services
import { useStore } from '@/store';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';

// types
import { Service, Session, } from '@/types';
import ABSService from '@/services/ABSService';
import AuthService from '@/services/AuthService';

// Firebase
import { customTokenSignin } from '@/auth';

export default {
  name: 'ServicePage',
  components: { IonPage, IonGrid, IonHeader, IonFooter, IonToolbar, IonTitle, IonContent, IonSpinner,
                IonButtons, IonButton, IonIcon, IonLabel, IonBackButton, IonCard, IonItem, IonSelect, IonSelectOption,
                ABEventsDetails, },
  setup() {
    const store = useStore();
    const { t } = useI18n();
    const route = useRoute();
    const router = useRouter();
    const { id: serviceId, userId } = route.params;

    // 1. declare state variables (ref to make them reactive)
    const loading = computed(() => store.state.loadingData || store.state.loadingUser);
    const user = computed(() => store.state.user);
    const isAB4User = computed(() => store.getters.isAB4User);
    const userSchoolAB4Intakes = computed(() => store.getters.userSchoolAB4Intakes);
    const selectedIntakeId = ref(userSchoolAB4Intakes.value[0]?.id);
    const service = computed<Service>(() => store.getters.getServiceById(serviceId));

    let accessTime, duration = 0, counterInterval;
    onIonViewDidEnter(() => {
      // Initial Access
      ABSService.insertPageAccessRecord(`ServicePage | ${serviceId}`, new Date(), null, userId);

      // Record Access & Leave Time
      accessTime = new Date();
      counterInterval = setInterval(() => (duration++), 1000);
    });
    onIonViewWillLeave(() => {
      if (accessTime && duration >= 3) {
        const { id, name } = service.value || {};
        ABSService.insertPageAccessRecord(`ServicePage | ${name} | ${id}`, accessTime, new Date(accessTime.getTime() + duration*1000), userId);
        accessTime = undefined;
        duration = 0; // reset;
        clearInterval(counterInterval);
      }
    });

    watch(user, async (currUser) => {
      /*
      if (currUser.id == null) {
        store.commit('setLoadingUser', true);
        const existingFirebaseUser = await AuthService.checkPhoneExists(userId, null, true); // userId is the phone
        if (existingFirebaseUser && existingFirebaseUser.s == 200 && existingFirebaseUser.t) {
          await customTokenSignin(existingFirebaseUser.t);
        } else {
          store.commit('setLoadingUser', false);
          if (!userId) {
            router.replace(`/login?redirectPath=${route.fullPath}`); // redirect to login page
          }
        }
      } else if (currUser.phone != userId) {
        store.dispatch('checkOnetimeGetUserInfo', userId);
      }
        */
    })

    watch(userSchoolAB4Intakes, () => {
      selectedIntakeId.value = userSchoolAB4Intakes.value[0]?.id;
    })
    
    // 3. return variables & methods to be used in template HTML
    return {
      // icons
      arrowBack,

      // variables
      loading,
      service, serviceId, userId,
      user, isAB4User,
      userSchoolAB4Intakes, selectedIntakeId,

      // methods
      t,
      isSurvey: () => (route.path.includes("survey")),
      getServiceName: () => {
        const { schoolId } = user.value;
        const serviceName = service.value.name || '';
        return schoolId ? serviceName.replace('[School]', `@ ${schoolId.toString().toUpperCase()}`) : serviceName;
      },
      
      // AB3 or AB4
      isAB3Service: computed(() => (serviceId == 's8179c188')),
      isAB4Service: computed(() => (serviceId == 's9215dbaf')),
    }
  },
}
